module.exports = __webpack_public_path__ + "img/nahradzi2_map.fd7c7562.jpg";